export default __webpack_public_path__ + "static/media/PaysageAvecUnePommeVerte60s.d4f1fe55.mp3";